import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- consumed only as a type via `typeof`
const AvatarSizes = {
	sm: 20,
	md: 40,
} as const;

export type AvatarProps = {
	size?: typeof AvatarSizes[keyof typeof AvatarSizes];
	url: string;
	/** Square with a 2px radius: team pictures, chips and the employee selector. Round elsewhere. */
	square?: boolean;
}

const StyledAvatar = styled.div<Omit<AvatarProps, 'square'> & { $square?: boolean }>`
	background-size: cover;
	background-image: url(${props => props.url});
	background-position: center;
	border-radius: ${props => props.$square ? '2px' : '50%'};
	width: ${props => props.size}px;
	height: ${props => props.size}px;
	flex-shrink: 0;
`;

export const Avatar = ({ size = 20, url, square }: AvatarProps) =>
	<StyledAvatar size={size} url={url} $square={square} />;

